import { Button, Checkbox, List, message, Modal, Typography } from 'antd';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	getCurrency,
	getObjectValues,
	nullSafeGet,
	nullSafeGetOrElse,
	stopDefaultEvents,
} from '../../utils/DataAccessUtils';
import UserListComponent from '../user_list_component/UserListComponent';
import UserSelectComponent from '../user_select_component/UserSelectComponent';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { defaultTier } from '../../utils/ApprovalHierarchyUtils';

export function ApprovalHierarchyEditUsers({
	visible,
	width,
	modalHeaderSteps,
	approvalHierarchy,
	setApprovalHierarchyTiers,

	onBack,
	onSubmit,

	isNTEBased,

	currentUser,
	userType,
	token,
	style,

	users,

	companyConfigFetching,
	usersFetching,
	updateBuyerCompanyConfig,
	companyConfig,
	fetchBuyerUsers,
	fetchUsers,
	getBuyerCompanyConfig,
}) {
	const [allowTechnicians, setAllowTechnicians] = useState(false);
	const [toggleLoading, setToggleLoading] = useState(false);

	const addUserListLoading = companyConfigFetching || usersFetching || toggleLoading;

	const tiers = nullSafeGet('tierDetails.0', approvalHierarchy)
		? nullSafeGetOrElse('tierDetails', approvalHierarchy, []).map((tier, i) => ({
				id: i,
				...tier,
		  }))
		: [defaultTier];
	const currency = getCurrency({ currentUser });

	useEffect(() => {
		getBuyerCompanyConfig(currentUser).then((result) => {
			const allowTechnicians = nullSafeGetOrElse(
				'config.approvalConfig.allowToApproveProposalByInternalTech',
				result,
				false
			);

			const fetchUserCall =
				allowTechnicians || userType === ROLE_TYPES.SUPPLIER ? 'internal' : 'buyer';

			if (userType === ROLE_TYPES.SUPPLIER) {
				fetchUsers();
			} else {
				fetchBuyerUsers(fetchUserCall);
			}
			setAllowTechnicians(allowTechnicians);
		});
	}, []);

	const toggleAllowTechnicians = () => {
		const type = !allowTechnicians ? 'internal' : 'buyer';
		setToggleLoading(true);
		updateBuyerCompanyConfig({
			...companyConfig,
			config: {
				...companyConfig.config,
				approvalConfig: {
					...companyConfig.config.approvalConfig,
					['allowToApproveProposalByInternalTech']: allowTechnicians,
				},
			},
		})
			.then(() => {
				fetchBuyerUsers(type)
					.then(() => {
						setAllowTechnicians(!allowTechnicians);
					})
					.catch((err) => message.error('Error fetching users'))
					.finally(() => setToggleLoading(false));
			})
			.catch((err) => {
				message.error('Error toggling allow technicians');
				setToggleLoading(false);
			});
	};

	let lastAmount;

	const [isDragging, setIsDragging] = useState(false);
	const [dragUser, setDragUser] = useState();

	const Users = getObjectValues(users).map((el) => ({
		...el,
		key: nullSafeGet('contact.email', el),
	}));
	const getApproverEmail = (approver) =>
		nullSafeGet('contact.email', approver) || nullSafeGet('email', approver);

	const filteredUsers = Users.map((user) => {
		user['tier'] = null;
		user['status'] = null;
		const userEmail = nullSafeGet('contact.email', user);
		tiers.map((tier) =>
			tier.approvers.map((levelUser) => {
				if (userEmail === getApproverEmail(levelUser)) {
					user['tier'] = tier;
					user['status'] = 'Current Tier: '.concat(tier.label);
				}
			})
		);
		return user;
	});

	const updateTiers = (tiers) => {
		let newTiers = tiers.map((tier, i) => {
			return { ...tier, label: i + 1 };
		});
		setApprovalHierarchyTiers(newTiers);
	};

	const removeUser = (tier, user, e) => {
		let pendingT = tiers.slice();
		const tierList = pendingT.map((t) => {
			if (t.id === tier.id) {
				t = removeUserFromLevel(user, tier);
			}
			return t;
		});
		updateTiers(tierList);
	};

	//User Selection
	const onChangeSearch = (tierId, value, e) => {
		const user = JSON.parse(value);
		const tierList = tiers.map((t) => {
			if (t.id === tierId) {
				t = addUserToTier(user, t);
			} else if (user.tier != null) {
				if (t.id === user.tier.id) {
					t = removeUserFromLevel(user, t);
				}
			}
			return t;
		});
		updateTiers(tierList);
	};

	const onSearchFocus = (self) => {};
	const onSearchBlur = (tier, e) => {
		let pendingTierList = JSON.parse(JSON.stringify(tiers));
		const tierList = pendingTierList.map((t) => {
			t.showSearch = false;
			return t;
		});
		updateTiers(tierList);
	};
	const onSearch = (value) => {};

	const addUserToTier = (user, t) => {
		t.approvers.push({
			approverType: 'user',
			contactType: nullSafeGetOrElse('contact.contactType', user, 'buyer'),
			email: nullSafeGet('contact.email', user),
			contact: nullSafeGet('contact', user),
		});
		return t;
	};
	const removeUserFromLevel = (user, t) => {
		const userEmail = getApproverEmail(user);
		for (let i = 0; t.approvers.length > i; i++) {
			if (getApproverEmail(nullSafeGet(`approvers.${i}`, t)) === userEmail) {
				t.approvers.splice(i, 1);
				break;
			}
		}
		return t;
	};

	const toggleSearch = (t, e) => {
		t = JSON.parse(t);
		t.showSearch = !t.showSearch;
		let pendingTierList = tiers.slice();
		const tierList = pendingTierList.map((tier) => {
			if (t.id === tier.id) {
				tier = t;
			}
			return tier;
		});

		document.body.addEventListener('onClick', clickOffDropdown.bind(t));
		updateTiers(tierList);
	};

	//Drag & Drop
	const userDragOver = (e) => {
		e.preventDefault();
		e.stopPropagation();
	};
	const startDragging = (user, e) => {
		setDragUser(JSON.parse(user));
	};
	const stopDragging = (e) => {
		setIsDragging(false);
	};
	const userDropped = (level, e) => {
		stopDefaultEvents(e);
		const user = dragUser;
		const userEmail = getApproverEmail(user);
		let pendingTierList = tiers.slice();
		const tierList = pendingTierList.map((t) => {
			if (t.id === level.id) {
				for (let i = 0; t.approvers.length > i; i++) {
					if (userEmail === getApproverEmail(nullSafeGet(`approvers.${i}`, t))) {
						t = removeUserFromLevel(user, t);
						break;
					}
				}
				t = addUserToTier(user, t);
			} else {
				for (let i = 0; t.approvers.length > i; i++) {
					if (userEmail === getApproverEmail(nullSafeGet(`approvers.${i}`, t))) {
						t = removeUserFromLevel(user, t);
						break;
					}
				}
			}
			return t;
		});
		updateTiers(tierList);
		setIsDragging(false);
		setDragUser(undefined);
	};
	const clickOffDropdown = (t, e) => {
		document.body.removeEventListener('onClick', clickOffDropdown.bind(t));
		toggleSearch(JSON.stringify(t), e);
	};

	return (
		<Modal
			visible={visible}
			width={width}
			title={modalHeaderSteps}
			okText={
				approvalHierarchy === null || approvalHierarchy === undefined
					? 'Create Approval Hierarchy'
					: 'Update Approval Hierarchy'
			}
			onCancel={onBack}
			cancelText="Back"
			onOk={(e) => {
				onSubmit();
			}}
			closable={false}
			maskClosable={false}
		>
			{userType === ROLE_TYPES.BUYER && (
				<div style={{ marginBottom: '20px' }}>
					<Checkbox
						disabled={addUserListLoading}
						checked={allowTechnicians}
						onChange={(e) => toggleAllowTechnicians()}
					/>
					<span style={{ marginLeft: '8px' }}>
						Include Internal Technician Team In Approval Hierarchy
					</span>
				</div>
			)}
			<div className={'UsersModalBody'}>
				{tiers.map((tier, i, tiers) => {
					lastAmount =
						nullSafeGetOrElse('amountUpto', tiers[i - 1], 0) === tier.amountUpto
							? lastAmount
							: nullSafeGetOrElse('amountUpto', tiers[i - 1], 0);
					return (
						<div key={tier.id.toString()} className={'UsersContainer'} style={tier}>
							<div className={'UsersContainerLabel'}>
								<span>{tier.name && tier.name !== '' ? tier.name : `Tier ${tier.label}`}</span>
								<Typography.Text className={'AmountLabel'}>
									{isNTEBased
										? tiers.length - 1 !== i
											? i === 0
												? `${currency.format(0, 0)} to ${currency.format(tier.amountUpto, 0)}`
												: `${currency.format(lastAmount, 0)} to ${currency.format(
														tier.amountUpto,
														0
												  )}`
											: `Over ${currency.format(tiers.length > 1 ? tiers[i - 1].amountUpto : 0, 0)}`
										: null}
								</Typography.Text>
							</div>
							<UserListComponent
								users={tier.approvers}
								token={token}
								style={style}
								allowRemove={true}
								removeUser={removeUser.bind(null, tier)}
								rightItems={null}
								emptyState={<span>No users have been added to this tier!</span>}
								trailingItems={[
									<List.Item
										key={'userDrop'}
										className={'DropUser'}
										onDrop={userDropped.bind(null, tier)}
										onDragOver={userDragOver}
										style={{
											height: isDragging ? '70px' : '0px',
											border: isDragging ? '4px solid purple' : '0px',
											borderRadius: isDragging ? '12px' : '0px',
											padding: '0px',
										}}
									></List.Item>,
									<List.Item key={'userAdd'} className={'AddUser'}>
										<Button
											loading={addUserListLoading}
											className={'AddUserButton'}
											onClick={toggleSearch.bind(null, JSON.stringify(tier))}
											style={{ display: tier.showSearch ? 'none' : 'inline-block' }}
										>
											Add User
										</Button>
										<div className="SearchUsers">
											{tier.showSearch ? (
												<UserSelectComponent
													config={{
														style: { width: '512px' },
														placeholder: 'Select a person',
														optionFilterProp: 'label',
														onChange: onChangeSearch.bind(null, tier.id),
														onFocus: onSearchFocus.bind(null),
														defaultActiveFirstOption: true,
														onBlur: (e) => onSearchBlur(tier, e),
														value: null,
														onSearch: onSearch,
													}}
													show={tier.showSearch}
													users={filteredUsers.map((user) => {
														return {
															...user,
															show: user.tier && tier.label === user.tier.label ? false : true,
														};
													})}
												/>
											) : null}
										</div>
									</List.Item>,
								]}
							/>
						</div>
					);
				})}
			</div>
		</Modal>
	);
}
